<template>
  <div class="platform-info-edit-wrp ft-12">
    <div v-loading="loading" class="alibaba-form">
      <slot name="errMsg"></slot>
      <Form
        ref="form"
        :baseItemId="form.baseItemId"
        :formSections="formSections"
        :showAuditResult="true"
        @fieldChanged="specificationsFieldChanged"
      >
        <template v-slot:cbuSendAddress>
          <section>
            <!-- <div class="title ft-12">
              <span>运费模板</span>
            </div> -->
            <div class="conf">
              <el-form-item label="发货地址:" :rules="[{ required: true, validator: validateAddress, trigger: 'change' }]" prop="shipSet" label-width="120px">
                  <div class="ship-wrp" style="display:inline-block;" v-if="shopList.length && Object.keys(addressValue).length">
                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                      <div class="shopname">
                        <img :src="item.icon" class="shop-img" />
                        <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px">
                          <el-image :src="item.channelIcon" style="width: 18px; height: 18px; overflow: unset; top: 4px"></el-image>
                        </el-tooltip>
                        <span>{{ item.shortTitle || item.title }}</span>
                      </div>
                      <template>
                        <el-select
                          :loading="selectLoading"
                          v-model="addressValue[item.id].addressId"
                          placeholder="请选择发货地址"
                          clearable
                          filterable
                          @change="handleAddressChange(item.id, $event)" 
                          @visible-change="visible => visibleChangeAddress(visible, item.id, item.userId)"
                          width="500px"
                        >
                          <el-option
                            v-for="ship in addressTemplate[item.id]"
                            :key="ship.addressId"
                            :label="ship.addressName"
                            :value="ship.addressId"
                            style="width: 500px"
                          >
                          </el-option>
                        </el-select>
                      </template>
                    </div>
                  </div>
                  <span v-else class="no-shops">暂无平台店铺</span>
                </el-form-item>
            </div>
          </section>
        </template>
        <template v-slot:shipShelf>
          <!-- 运费模板 -->
          <section>
            <div class="title ft-12">
              <span>运费模板</span>
            </div>
            <div class="conf">
              <el-form-item label="运费设置：">
                <el-row v-if="shopList.length && Object.keys(shipsValue).length">
                  <el-col v-for="item in shopList" :key="item.id" :span="12" class="set-ship">
                    <el-image :src="item.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
                    <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px">
                      <el-image :src="item.channelIcon" style="width: 18px; height: 18px"></el-image>
                    </el-tooltip>
                    <span class="shop-title">{{ item.shortTitle || item.title }}</span>
                    <el-select
                      v-model="shipsValue[item.id].extendId1"
                      placeholder="请选择"
                      width="150px"
                      @change="tempTypeChange(item.id, item.userId)"
                    >
                      <el-option label="使用运费模版" value="T"> </el-option>
                      <el-option label="使用运费说明" value="C"> </el-option>
                      <el-option label="卖家承担运费" value="F"> </el-option>
                    </el-select>
                    <template v-if="['T'].includes(shipsValue[item.id].extendId1)">
                      <el-select
                        :loading="selectLoading"
                        v-model="shipsValue[item.id].templateId"
                        placeholder="请选择运费模板"
                        clearable
                        filterable
                        @visible-change="visible => visibleChange(visible, item.id, item.userId)"
                        width="150px"
                        class="ml-10"
                      >
                        <el-option
                          v-for="ship in shipsTemplate[item.id]"
                          :key="ship.templateId"
                          :label="ship.templateName"
                          :value="ship.templateId"
                          style="width: 150px"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-col>
                </el-row>
                <span v-else class="no-shops">暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <!-- 上架设置 -->
          <!-- <section>
                <div class="title ft-12">
                  <span>上架设置</span>
                </div>
                <div class="conf">
                  <el-form-item 
                    label="上架设置:" 
                    :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
                      <el-radio-group v-model="isOnshelf">
                          <el-radio :label="1">立即上架</el-radio>
                          <el-radio :label="2">放入草稿箱</el-radio>
                      </el-radio-group>
                  </el-form-item>
                </div>
              </section> -->
        </template>
      </Form>
    </div>
  </div>
</template>

<script>
import { getForm, getItemPublishSchemaPropV2, getFreightTemplateList,batchAlibabaShippingAddress } from '@/servers/prod/center/alibaba';
import Form from './components/Form/Form.vue';
import { generateSections } from './utils/sections';
import { form2data, dataDefaultValue, formatFormData, formatDataForm, merge_fieldDescriptorList } from './utils/data';
import { getDistributionConfig } from '@servers/prod/conf/index.js';

import { mapActions, mapGetters } from 'vuex';
import { cloneDeep, isEmpty } from 'lodash';
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';

export default {
  components: { Form },
  mixins: [validateMixin, shopListMixin],
  inject: {
    isGroupPuhuo: { default: false },
  },
  provide() {
    return {
      alibabaFormVm: this,
      openSource:this.openSource
    };
  },
  props: {
    form: {
      type: Object | Array,
      default() {
        return {};
      },
    },
    shopsList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    changeToBase: Function,
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      formKey: 'alibabaForm',
      schemas: {},
      formSections: [],
      loading: false,
      shipsTemplate: {}, // 运费模板列表
      shipsValue: {}, // 运费模板值，{shopId: templateId}
      shipsTemplateCaches: {},
      addressValue:{}, //运费模版值
      addressTemplate: {}, //发货地址模版立碑
      addressTemplateCaches: {}, // 发货地址模版缓存  
      selectLoading: false,
      catPropSecondaryList: [],
      originalTemplateConfig: null, // 原始运费模板配置（用于保存时恢复未显示店铺的数据）
      originalSendAddressConfig: null, // 原始发货地址配置（用于保存时恢复未显示店铺的数据）
      platform: '1688', // 平台
    };
  },
  watch: {
    form: {
      handler(v, o) {
        if (isEmpty(v)) return
        this.clearAlibabaInfo();
        const origin_form = cloneDeep(v)
        origin_form.detailHasCategory = origin_form.categoryIds
        this.setOriDetailData(origin_form);
        this.initAlibabaForm(origin_form);
        // 保存原始 templateConfig，用于保存时恢复未显示店铺的数据
        if (origin_form.templateConfig && origin_form.templateConfig.length) {
          this.originalTemplateConfig = cloneDeep(origin_form.templateConfig);
        }
        // 保存原始 sendAddressConfig，用于保存时恢复未显示店铺的数据
        if (origin_form.sendAddressConfig && origin_form.sendAddressConfig.length) {
          this.originalSendAddressConfig = cloneDeep(origin_form.sendAddressConfig);
        }
        this.getConf(v?.sendAddressConfig || []);
      },
      immediate: true,
      deep: true,
    },
    categoryId: {
      handler(v) {
        v && this.getUiData();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['alibabaForm', 'alibabaData', 'shops_defaultShopId', 'shops_getCategoryPropShopId']),
    categoryId() {
      let categoryIds = this.alibabaForm.categoryIds || [];
      return categoryIds[categoryIds.length - 1] || '';
    },
    shopList() {
      let list = this.getShopList(this.platform);
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list
    },
  },
  methods: {
    ...mapActions([
      'initAlibabaForm',
      'updateAlibabaForm',
      'setOriDetailData',
      'clearAlibabaInfo',
      'updateCatePropShopIndex',
      'initAlibabaSecondary',
    ]),

    validateAddress(rule, value, callback) {
      const hasValidAddress = Object.values(this.addressValue).some(item => item.addressId);
      if (!hasValidAddress) {
        callback(new Error('请选择发货地址'));
      } else {
        callback();
      }
    },

    async updateCatPropUI(cb) {
      this.updateCatePropShopIndex('alibaba');
      this.loading = true;
      const res = await getForm({
        shopId: this.shops_getCategoryPropShopId('alibaba'),
        categoryId: this.categoryId,
      });
      if (!res) {
        this.loading = false;
        return;
      }
      let editorForce = false;
      const { formSections } = generateSections(res);
      let newCatProp = null;
      function find(item) {
        if (newCatProp && !editorForce) return;
        if (item.name === 'catProp') {
          newCatProp = item;
          return;
        }
        if (item.children && item.children.length) {
          item.children.forEach(find);
        }
      }
      formSections.forEach(find);
      // 若没生成新的类目属性ui则不做任何变动
      if (!newCatProp && !editorForce) return (this.loading = false);

      let newFormSections = [...this.formSections];
      let catPropSetted = false;
      function findAndSet(item, index, parent) {
        if (catPropSetted && !editorForce) return;
        if (item.name === 'catProp') {
          catPropSetted = true;
          parent[index] = newCatProp;
          return;
        }
        if (item.children && item.children.length) {
          item.children.forEach(findAndSet);
        }
      }
      newFormSections.forEach(findAndSet);
      this.formSections = newFormSections;
      this.loading = false;
      cb && cb();
    },

    async getUiData() {
      window._alibaba_cutomId = -2; // 用于一些自定义下拉框的id生成
      this.loading = true;
      this.formSections = [];
      const res = await getForm({
        shopId: this.shops_defaultShopId('alibaba'),
        categoryId: this.categoryId,
      });
      if (!res) {
        this.loading = false;
        return false;
      }
      this.schemas = res;

      // 动态表单
      const { formSections } = generateSections(res);
      this.formSections = formSections.filter(item => {
        if (item && item.children?.length) {
          const newCatPropChildren = item.children.find(item => item.name === 'catProp')?.children;
          if (newCatPropChildren) {
            this.catPropSecondaryList = newCatPropChildren.filter(item => item?._oriRules?.childProp === 'true');
          }
          return true;
        }
        return false;
      });
      const isSupportQuickBackInventory = res['isSupportQuickBackInventory']?.defaultValue === 'true';
      const _form = formatDataForm(dataDefaultValue(this.form), formSections);
      if (!((_form.supplyType || []).includes('2') && isSupportQuickBackInventory)) {
        _form['kf'] = '';
      }

      this.updateAlibabaForm({ ..._form, isSupportQuickBackInventory });
      this.loading = false;
      this.$nextTick(() => {
        this.catPropSecondaryList.length && this.getSecondaryData(true);
      });
    },
    getFieldDescriptorList() {
      return merge_fieldDescriptorList(cloneDeep(this.alibabaData.fieldDescriptorList), [
        ...formatFormData(cloneDeep(this.alibabaForm), this.formSections),
      ]);
    },

    async getSecondaryData(first) {
      const fieldDescriptorList = this.getFieldDescriptorList();
      const catPropField = fieldDescriptorList.find(item => item.name === 'catProp');
      let subCatPropData = {};
      catPropField.children
        .filter(item => item.defaultValue)
        .map(item => {
          subCatPropData[item.name] = {
            value: item.defaultValue,
            text: item.valueDisplayName,
          };
        });
      if (!this.categoryId) return;
      const res = await getItemPublishSchemaPropV2({
        shopId: this.shops_getCategoryPropShopId('alibaba'),
        categoryId: this.categoryId,
        dataBody: JSON.stringify({
          data: { catProp: subCatPropData },
        }),
      });
      this.updateSecondaryForm(res, first);
    },
    updateSecondaryForm(res, first) {
      // 找到新的类目属性的children
      const { formSections } = generateSections(res);
      let _formSections = cloneDeep(this.formSections);
      _formSections = _formSections.map(item => {
        const secondarySectionChildren = formSections.find(section => section.title === item.title).children;
        const newChildren = [];
        item.children.forEach(fieldItem => {
          const findIndex = secondarySectionChildren.findIndex(secondaryFieldItem => secondaryFieldItem.name === fieldItem.name); // 新的级联属性中是否有当前属性
          if (findIndex > -1) {
            // 原form中存在且新的次级属性也存在的更新次属性
            newChildren.push({ ...cloneDeep(secondarySectionChildren)[findIndex], isSecondary: true });
            secondarySectionChildren.splice(findIndex, 1);
          } else if (!fieldItem.isSecondary) {
            newChildren.push(fieldItem);
          }
        });
        // 原form没有的，添加次级属性
        secondarySectionChildren.forEach(fieldItem => {
          newChildren.push({ ...fieldItem, isSecondary: true });
        });
        item.children = newChildren;
        return item;
      });
      this.formSections = _formSections;
      if (first) {
        let _form = formatDataForm(this.alibabaData, this.formSections);
        if (!((_form.supplyType || []).includes('2') && this.alibabaForm.isSupportQuickBackInventory)) {
          _form['kf'] = '';
        }
        this.updateAlibabaForm(_form);
      }
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        let specificationsValid = null;
        const saleProp = this.$refs?.form?.$refs?.saleProp;
        if (saleProp) {
          specificationsValid = saleProp[0]?.validateSpecifications();
        } else {
          specificationsValid = true;
        }
        this.specificationsValidResult = specificationsValid;
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    async valid_form() {
      return new Promise(async resolve => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        const refForm = this.$refs.form.$refs.form;
        const $salePropTableRef = this.$refs.form.$refs.salePropTable; // 工业类目销售属性
        const $logisticsWeightTableRef = this.$refs.form.$refs.logisticsWeightTable;
        let salePropData = null;
        let logisticsWeightTableList = null;
        if($salePropTableRef?.length) {
          salePropData = await $salePropTableRef?.[0]?.method_getData();
        }
        if($logisticsWeightTableRef?.length) {
          logisticsWeightTableList = await $logisticsWeightTableRef?.[0]?.method_getData();
        }
        if (refForm) {
          setTimeout(() => {
            refForm.validate(valid => {
              resolve(salePropData && logisticsWeightTableList && valid);
            });
          }, 300);
        } else {
          resolve(false);
        }
      });
    },
    handleTemplateConfig() {
      const arr = [];
      Object.keys(this.shipsValue).forEach(shopId => {
        const curValue = this.shipsValue[shopId];
        if (curValue.extendId1) {
          const item = {
            ...curValue,
          };
          if (!['T'].includes(curValue.extendId1)) {
            item.templateId = '';
            item.templateName = '';
          } else {
            const templateName =
              (this.shipsTemplate[shopId] || []).find(temp => temp.templateId === curValue.templateId)?.templateName || '';
            item.templateName = templateName;
          }
          arr.push(item);
        }
      });
      return JSON.stringify(arr);
    },
    // 获取发货地址配置
    handleSendAddressConfig(){
      const arr = [];
      Object.keys(this.addressValue).forEach(shopId => {
        const curValue = this.addressValue[shopId];
        if (curValue.addressId) {
          arr.push({
            shopId: curValue.shopId,
            addressId: curValue.addressId,
            addressName: curValue.addressName
          });
        }
      });
      return JSON.stringify(arr);
    },

    async method_getFormData() {
      return new Promise(resovle => {
        if (!this.alibabaForm.categoryIds.length) {
          this.$message.error('请选择商品分类');
          resovle(false);
          return;
        }
        this.validPage().then(async valid => {
          if (!valid) {
            this.$message.error('请完善表单');
            resovle(false);
            return false;
          }
          let formData = form2data(this.alibabaForm, this.alibabaData);
          let salePropData = null;
          const $salePropRef = this.$refs.form.$refs.saleProp;
          const $salePropTableRef = this.$refs.form.$refs.salePropTable; // 工业类目销售属性
          if ($salePropRef?.length) {
            salePropData = $salePropRef?.[0]?.method_getData();
            if (!salePropData) {
              this.$message.error('请完善产品规格！');
              resovle(false);
              return false;
            }
            let [specifications = [], skuList = [], sizeGroup = {}, isGroup = 0] = salePropData || [];
            formData.specifications = specifications;
            formData.skuList = skuList;
            formData.isGroup = isGroup;
          } else if ($salePropTableRef?.length) {
            salePropData = await $salePropTableRef?.[0]?.method_getData();
            if (!salePropData) {
              this.$message.error('请完善产品规格！');
              resovle(false);
              return false;
            }
            formData.skuList = salePropData;
            formData.specifications = this.alibabaData.specifications;
          } else {
            formData.specifications = [];
            formData.skuList = [];
          }
          const $logisticsWeightTableRef = this.$refs.form.$refs.logisticsWeightTable;
          if ($logisticsWeightTableRef) {
            const logisticsWeightTableList = await $logisticsWeightTableRef?.[0].method_getData();
            if (!logisticsWeightTableList) {
              this.$message.error('请完善物流件重尺!');
              resovle(false);
              return false;
            } else {
              if (formData.showLogisticsCategory === 'item') {
                formData.itemOfficialLogistics = logisticsWeightTableList[0];
              } else {
                formData.skuList.forEach(sku => {
                  const logisticItems = ['length', 'width', 'height', 'weight', 'volume'];
                  let findItem = logisticsWeightTableList.find(item => item._skuid === sku._skuid) || {};
                  if ($salePropTableRef) {
                    const findIndustry = (sku.industrySkuSpecifications || []).find(industry => industry.name === "规格型号") || {}
                    findItem = logisticsWeightTableList.find(item => item['规格型号'] === findIndustry.value) || {};
                  }
                  logisticItems.forEach(i => {
                    sku[i] = findItem[i];
                  });
                });
              }
            }
          }
          const fieldDescriptorList = this.getFieldDescriptorList();
          // 报价方式为 按产品规则报价 时，区间报价需为空
          if(this.alibabaForm.quotationType != '2') {
            const findItem = fieldDescriptorList.find(item => item.name === 'priceRange')
            if(findItem) {
              findItem.defaultValue = '';
            }
          }
          const findIsSupportQuickBackInventory = fieldDescriptorList.find(item => item.name === 'isSupportQuickBackInventory')
          const isSupportQuickBackInventory = this.alibabaForm.isSupportQuickBackInventory ? 'true' : 'false';
          if(findIsSupportQuickBackInventory) {
            findIsSupportQuickBackInventory.defaultValue = isSupportQuickBackInventory;
          } else {
            fieldDescriptorList.push({
              name: 'isSupportQuickBackInventory',
              defaultValue: isSupportQuickBackInventory,
            })
          }
         
          formData.fieldDescriptorList = fieldDescriptorList;
          formData.categoryId = this.alibabaForm.categoryIds[this.alibabaForm.categoryIds.length - 1];
          formData.shopId = this.shops_getCategoryPropShopId('alibaba');
          formData.templateConfig = (() => {
            let current = JSON.parse(this.handleTemplateConfig());
            current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
            return JSON.stringify(current);
          })();
          formData.sendAddressConfig = (() => {
            let current = JSON.parse(this.handleSendAddressConfig());
            current = this.mergeHiddenShopData(current, this.originalSendAddressConfig, this.shopList);
            return JSON.stringify(current);
          })();
          console.log(
            formData.fieldDescriptorList,
            formData,
            cloneDeep(this.alibabaForm),
            '----formData.fieldDescriptorList, formData, this.alibabaForm, this.alibabaData--'
          );
          // resovle(false);
          // return;
          resovle({ ...formData });
        });
      });
      // 获取数据保存
      // return this.formData;
    },
    clear_specification() {
      this.$refs.form.$refs.saleProp && this.$refs.form.$refs.saleProp[0]?.clear_specification();
    },

    // 处理详情 templateConfig
    initTemplateConfig(templateList = []) {
      const shopList = this.shopList;
      const ships = {};
      const shipsTemp = {};
      const detailTemplates = this.alibabaForm.templateConfig || [];

      shopList.forEach(shop => {
        const { id, channel } = shop;
        const findTemp = templateList.find(temp => temp.shopId == id) || {};
        const findDetailTemp = detailTemplates.find(temp => temp.shopId == id) || {};
        ships[id] = {
          shopId: id,
          templateId: '',
          templateName: '',
          channel,
          extendId1: '',
          valuation: null,
          ...findTemp,
        };
        if (findDetailTemp.extendId1) {
          ships[id] = {
            ...ships[id],
            ...findDetailTemp,
          };
        }

        if (ships[id].extendId1 && ships[id].templateId) {
          shipsTemp[id] = [{ templateName: ships[id].templateName, templateId: ships[id].templateId }];
        }
      });
      this.shipsTemplate = shipsTemp;
      this.shipsValue = ships;
    },
    // 根据接口返回的发货地址数据进行初始化
    initShipAddressTemplate(addressTemplateList) {
      const shopList = this.shopList;
      const detailSendAddress = this.alibabaForm.sendAddressConfig || [];
      
      // 初始化每个店铺的地址值
      shopList.forEach(shop => {
        const { id } = shop;
        // 初始化地址值
        if (!this.addressValue[id]) {
          this.$set(this.addressValue, id, {
            shopId: id,
            addressId: '',
            addressName: ''
          });
        }
        if (!this.addressTemplate[id]) {
          this.$set(this.addressTemplate, id, []);
        }

        // 获取两个数据源中对应店铺的数据
        const templateAddress = addressTemplateList?.find(temp => temp.shopId === id);
        const detailAddress = detailSendAddress?.find(temp => temp.shopId === id);

        // 优先使用 addressTemplateList 的数据，如果没有则使用 detailSendAddress 的数据
        const finalAddress = templateAddress || detailAddress;

        if (finalAddress) {
          // 更新地址值
          this.$set(this.addressValue, id, {
            shopId: id,
            addressId: finalAddress.addressId || '',
            addressName: finalAddress.addressName || ''
          });

          // 更新模板数据
          this.$set(this.addressTemplate, id, [{
            addressId: finalAddress.addressId,
            addressName: finalAddress.addressName
          }]);
        }
      });
    },
    handleAddressChange(shopId, addressId) {
      // 找到对应的地址信息
      const selectedAddress = this.addressTemplate[shopId]?.find(item => item.addressId === addressId);
      if (selectedAddress) {
        // 更新 addressValue
        this.addressValue[shopId] = {
          ...this.addressValue[shopId],
          addressId: selectedAddress.addressId,
          addressName: selectedAddress.addressName
        };
      }
    },
    // 发货地址默认展示的列表内容
    async visibleChangeAddress(visible, shopId, userId) {
      if (!visible) return;
      await this.getShopAddressList({shopId, userId});
    },
     // 获取店铺列表的发货地址
     async getShopAddressList({shopId,userId,isRefresh}){
        const addressCacheType = 'addressCacheType';
        const cacheKey = `${shopId}_${addressCacheType}`;
        if (this.addressTemplateCaches[cacheKey] && !isRefresh) {
            this.addressTemplate[shopId] = this.addressTemplateCaches[cacheKey];
          } else {
                this.selectLoading = true;
                const res = await batchAlibabaShippingAddress({userId})
                if(res.result && res.result.length){
                    const list = res.result.map(item => ({ addressId: item.id + '', addressName: item.fullAddress }));
                    this.addressTemplate[shopId] = list;
                    // this.shipsTemplateCaches[cacheKey] = list;
                    this.addressTemplateCaches[cacheKey] = list;
                    this.selectLoading = false;
                } else {
                  // 错误处理
                  this.addressTemplate[shopId] = [];
                    this.selectLoading = false;
                }
          }
        },
    tempTypeChange(shopId, userId) {
      this.getTemplateList(shopId, userId);
    },
    async visibleChange(visible, shopId, userId) {
      if (!visible) return;
      const curShipsTemp = this.shipsTemplate[shopId];
      const curValue = this.shipsValue[shopId];
      // if (!curShipsTemp?.length || (curShipsTemp?.length === 1 && curShipsTemp[0].id === curValue.templateId)) {
      await this.getTemplateList(shopId, userId);
      // }
    },

    async getTemplateList(shopId, userId) {
      const freightType = this.shipsValue[shopId].extendId1;
      if (!['T'].includes(freightType)) return;
      const cacheKey = `${shopId}_${freightType}`;
      if (this.shipsTemplateCaches[cacheKey]) {
        this.shipsTemplate[shopId] = this.shipsTemplateCaches[cacheKey];
        return;
      }
      this.selectLoading = true;
      const res = await getFreightTemplateList({ userId, webSite: '1688', type: freightType });
      const list = res.map(item => ({ templateId: item.id + '', templateName: item.name }));
      const curValue = this.shipsValue[shopId];
      const findItem = (list || []).find(item => item.templateId === curValue.templateId);
      if (!findItem) {
        this.shipsValue[shopId].templateId = '';
        this.shipsValue[shopId].templateName = '';
      }
      this.shipsTemplate[shopId] = list;
      this.shipsTemplateCaches[cacheKey] = list;
      this.selectLoading = false;
    },
    // 获取配置
    async getConf(sendAddressConfig) {
      const res = await getDistributionConfig({ shopType: '1688' });
      // 上架设置
      // this.isOnshelf = this.alibabaForm.isOnshelf ? this.alibabaForm.isOnshelf : (res?.shelfState || 1);
      this.initTemplateConfig(res?.templateList || []);
      this.initShipAddressTemplate(res.sendAddressTemplateList || [])

    },
  },
  mounted() {},
  destroyed() {
    this.clearAlibabaInfo();
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.set-ship {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.shop-title {
  width: 130px;
  margin: 0 16px 0 10px;
  font-size: 12px;
  color: #606266;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.ship-wrp {
  margin-left: 5px;
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    & > div {
      margin-right: 16px;
    }
    .shopname {
      width: 150px;
      display: flex;
      text-align: right;
      font-size: 12px;
      vertical-align: middle;
      display: inline-block;
      margin-left: 10px;
      color: #606266;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      .shop-img {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }
}

.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>